import { render, staticRenderFns } from "./CardAnnouncementEmployees.vue?vue&type=template&id=3f196918"
import script from "./CardAnnouncementEmployees.vue?vue&type=script&lang=js"
export * from "./CardAnnouncementEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports